import React from 'react';
import { Row, Col, ListGroup, Button, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Message from '../components/Message';

// NOT: Bu bileşen artık `notVerified` mutasyonunu ÇAĞIRMIYOR. Eski sürüm,
// istemciden gelen resNumber'a bakarak backend'e "bu siparişi sil" isteği
// gönderiyordu - bu, kimliği doğrulanmış herhangi bir client'ın rastgele bir
// siparişi silebilmesine izin veren bir güvenlik açığıydı. Ödenmemiş/terk
// edilmiş siparişlerin temizliği artık backend'deki zamanlanmış görev
// (server.js -> myFunction2 / cleanupUnpaidOrders, 1 saat sonra) tarafından
// yapılıyor. Bu ekran sadece hata mesajını gösteriyor.
const CardVerification1 = () => {
  const { resNumber } = useParams();
  const navigate = useNavigate();

  const handleGoBack = () => navigate('/payment');
  const gotoHomeScreen = () => navigate('/');

  const knownErrorMessages = {
    '888': 'Kart Onaylanmadı',
    HashDataError: 'Hash Data Eşleşmiyor',
  };

  return (
    <Card>
      <ListGroup.Item>
        <Message variant="danger">
          {knownErrorMessages[resNumber] || `Kart doğrulama başarısız oldu (${resNumber})`}
        </Message>
      </ListGroup.Item>

      <Row>
        <Col xs={12} md={8} lg={4}>
          <ListGroup.Item>
            <Button type="button" className="btn btn-block" onClick={handleGoBack}>
              Tekrar Dene
            </Button>
          </ListGroup.Item>
        </Col>
        <Col xs={8} md={8} lg={8}>
          <ListGroup.Item>
            <Button type="button" className="btn btn-block" onClick={gotoHomeScreen}>
              Markete Dön
            </Button>
          </ListGroup.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default CardVerification1;